<template>
  <v-container v-if="$store.getters.user" class="test_red">
    <v-row justify="center" no-gutters class="test_blue">
      <v-col cols="12" md="10" lg="8" class="test_yellow">
        <div class="content">
          <div style="margin-top: 30px">
            <h1 style="margin-left: 10px">
              {{ $t("customerProfile.shareComp.title") }}
            </h1>
            <v-list>
              <v-list-item
                v-for="(item, index) in items"
                :key="index"
                class="pa-0"
              >
                <v-list-item-action>
                  <v-avatar class="pa-0 ma-0">
                    <span class="circle-number">{{ index + 1 }}</span>
                  </v-avatar>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title class="wrap-text">{{
                    $t(`customerProfile.shareComp.${item}`, {
                      value: promoReward,
                    })
                  }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </div>
          <h3 class="subtitle" style="margin-bottom: 30px">
            {{ $t("customerProfile.shareComp.subTitle") }}
          </h3>
          <div v-if="user.promoCode" class="box">
            <div>
              <div class="title2">
                {{ $t("customerProfile.shareComp.codeTitle") }}
              </div>
              <div class="title">{{ user.promoCode }}</div>
            </div>
            <v-btn class="share-button" icon @click="copyToClipboard">
              <v-icon>mdi-content-copy</v-icon>
            </v-btn>
          </div>
          <div style="margin-top: 50px" class="divider-text">
            {{ $t("customerProfile.shareComp.dividerText") }}
          </div>
          <!--          <v-divider></v-divider>-->
          <v-row style="margin-top: 5px">
            <v-btn icon @click="shareOnFacebook">
              <v-icon size="24">mdi-facebook</v-icon>
            </v-btn>
            <v-btn icon @click="shareOnTwitter">
              <v-icon size="24">mdi-twitter</v-icon>
            </v-btn>
            <!--            <v-btn icon @click="shareOnInstagram">-->
            <!--              <v-icon size="24">mdi-instagram</v-icon>-->
            <!--            </v-btn>-->
            <v-btn icon @click="shareOnLinkedIn">
              <v-icon size="24">mdi-linkedin</v-icon>
            </v-btn>
          </v-row>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "ShareComponent",
  data: () => ({
    items: ["list1", "list2"],
    promoCode: "867K",
    credits: 0,
    promoReward: null,
  }),
  computed: {
    ...mapGetters(["user"]),
  },
  created() {
    this.promoCode = this.user.promoCode;
    this.credits = this.user.credits;
    this.promoReward = this.$store.getters.appInfo?.promoReward;
  },
  methods: {
    copyToClipboard() {
      const el = document.createElement("textarea");
      el.value = this.promoCode;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      Toast.fire({
        icon: "success",
        title: "Copied!",
      });
    },
    shareOnFacebook() {
      const promoCode = this.promoCode;
      const baseUrl = window.location.origin;
      const shareUrl = `${baseUrl}/?promo=${promoCode}`;
      const facebookShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`;
      window.open(facebookShareUrl, "_blank");
    },
    shareOnTwitter() {
      const promoCode = this.promoCode;
      const amountDiscount = this.credits;

      const message = encodeURIComponent(
        `Hello everyone! 😊\n\nI just wanted to share my discount code with all of you: #${promoCode}, which gives you a ${amountDiscount} discount on takeaway.`
      );
      const baseUrl = window.location.origin;

      const shareUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(
        baseUrl
      )}&text=${message}`;
      window.open(shareUrl, "_blank");
    },
    shareOnLinkedIn() {
      // Add your LinkedIn sharing logic here
      const promoCode = this.promoCode;
      const baseUrl = window.location.origin;
      const shareUrl = `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(
        baseUrl
      )}&title=${encodeURIComponent(
        this.promoCode
      )}&summary=${encodeURIComponent(promoCode)}`;
      window.open(shareUrl, "_blank");
    },
    shareOnInstagram() {
      const promoCode = this.promoCode;
      const shareText = `Check out this discount code: ${promoCode}`;
      const shareUrl = `https://kolumbia.dksnap.com/`;
      const instagramShareUrl = `https://www.instagram.com/?url=${shareUrl}&caption=${encodeURIComponent(
        shareText
      )}`;
      window.open(instagramShareUrl, "_blank");
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.circle-number {
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  border-radius: 50%;
  background-color: #eaf5fc;
  width: 30px;
  height: 30px;
  color: var(--v-primary-base) !important;
}
.title {
  flex: 1;
}
.title2 {
  flex: 1;
  font-size: 1rem;
}
.share-button {
  margin-left: 10px;
}
.subtitle {
  color: var(--v-primary-base) !important;
}
.wrap-text {
  white-space: normal;
}
.box {
  background-color: rgb(245, 245, 245);
  display: flex;
  border-radius: 5px;
  border-width: 2px !important;
  justify-content: space-between;
  width: 100%;
  align-items: center;
  padding: 20px;
  margin-left: 10px;
}
.divider-text {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px 0;
  color: #999;
}
</style>
